<template>
    <div class="layout">
        <aside class="sidebar" :class="{ collapsed: isCollapsed }">
            <ul>
                <li @click="toggleMenu">
                    <img :src="menuIcon" alt="Toggle Menu" />
                    <span>{{ isCollapsed ? 'Expandir' : 'Recolher' }}</span>
                </li>

                <li v-if="ckSu" @mouseover="showSettingsMenu = true" @mouseleave="showSettingsMenu = false">
                    <img src="@/assets/icons/menuSettings.svg" />
                    <span>Configurações</span>
                    <div v-if="showSettingsMenu" class="submenu" :class="{ 'relative': isCollapsed }">
                        <ul>
                            <li @click="setComponenteAtivo('GabineteDepartamentosTabPage', 'GABINETE - CADASTRO DE DEPARTAMENTOS')">
                                <img src="@/assets/icons/menuOffice.svg" />
                                <span>Departamentos</span>
                            </li>

                            <li @click="setComponenteAtivo('GabineteTpPessoasTabPage', 'GABINETE - GRUPO DE PESSOAS')">
                                <img src="@/assets/icons/menuTipos.svg" />
                                <span>Grupos de Pessoas</span>
                            </li>

                            <li v-if="ckLoginAdmin" @click="selectOption('UsuariosTabPage', 'USUÁRIOS')">
                                <img src="@/assets/icons/menuUsers.svg" />
                                <span>Usuários</span>
                            </li>
                        </ul>
                    </div>
                </li>


                <li @click="setComponenteAtivo('GabinetePessoasTabPage', 'CADASTRO DE PESSOAS')">
                    <img src="@/assets/icons/menuPessoas.svg" />
                    <span>Pessoas</span>
                </li>


                <li v-if="ckRecepcao || ckSu" @click="setComponenteAtivo('GabAgendaRecepcaoPage', 'AGENDA RECEPÇÃO')">
                    <img src="@/assets/icons/menuAgenda.svg" />
                    <span>Agenda Recepção</span>
                </li>


                <li v-if="ckGestor || ckSu" @click="setComponenteAtivo('GabAgendaPrefeitoPage', 'AGENDA PREFEITO')">
                    <img src="@/assets/icons/menuAgenda.svg" />
                    <span>Agenda Prefeito</span>
                </li>


                <li v-if="ckSu" @click="setComponenteAtivo('GabineteAtendimentoExpressoEditPage', 'INICIAR ATENDIMENTO')">
                    <img src="@/assets/icons/service.svg" />
                    <span>Iniciar Atendimento</span>
                </li>


                <li v-if="ckSu" @click="setComponenteAtivo('GabineteAgendaEditPage', 'INCLUIR AGENDA')">
                    <img src="@/assets/icons/menuAgendaAdd.svg" />
                    <span>Inserir Agenda</span>
                </li>


                <li v-if="ckSu" @click="setComponenteAtivo('GabSolicitacaoIncluirPage', 'INCLUIR SOLICITAÇÃO')">
                    <img src="@/assets/icons/menuAgendaAdd.svg" />
                    <span>Inserir Solicitação</span>
                </li>


                <li v-if="ckSu" @click="setComponenteAtivo('GabineteAgendaTabPage', 'LISTA AGENDAMENTOS')">
                    <img src="@/assets/icons/menuCalendarList.svg" />
                    <span>Lista de Agendamentos</span>
                </li>


                <li v-if="ckGestor || ckSu" @click="setComponenteAtivo('GabSolicitacoesTabPage', 'SOLICITAÇÕES')">
                    <img src="@/assets/icons/menuCalendarList.svg" />
                    <span>Solicitações</span>
                </li>


                <li v-if="ckSu" @click="setComponenteAtivo('GabineteAgendaCalendarioPage', 'CALENDÁRIO AGENDAMENTOS')">
                    <img src="@/assets/icons/menuAgenda.svg" />
                    <span>Agenda</span>
                </li>


                <li v-if="ckGestor || ckSu" @mouseover="showRelatoriosMenu = true" @mouseleave="showRelatoriosMenu = false">
                    <img src="@/assets/icons/menuPrinter.svg" />
                    <span>Relatórios</span>
                    <div v-if="showRelatoriosMenu" class="submenu" :class="{ 'relative': isCollapsed }">
                        <ul>
                            <li v-if="ckGestor || ckSu" @click="selectOption('GabAgendaReportPage', 'RELATÓRIO AGENDA')">
                                <span>Agenda</span>
                            </li>

                            <li v-if="ckGestor || ckSu" @click="selectOption('GabineteAniversariantesReportPage', 'RELATÓRIO DE ANIVERSARIANTES')">
                                <span>Aniversariantes</span>
                            </li>

                            <li v-if="ckGestor || ckSu" @click="selectOption('GabineteRequisicoesReportPage', 'RELATÓRIO DE SOLICITAÇÕES')">
                                <span>Solicitações</span>
                            </li>
                        </ul>
                    </div>
                </li>

                <li @click="setComponenteAtivo('UsuarioViewPage', 'DADOS DO USUÁRIO')">
                    <img src="@/assets/icons/menuUser.svg" />
                    <span>Meus Dados</span>
                </li>

                <li @click="confirmLogout">
                    <img src="@/assets/icons/menuLogout.svg" />
                    <span>Desconectar</span>
                </li>
            </ul>
        </aside>

        <main class="content">
            <header class="header">
                <div class="header-title">{{ nmTitulo ? nmTitulo : 'GESTÃO DE GABINETE' }}</div>
                <div style="align-items: center; display: flex;">
                    <div class="user-info">
                        <div class="user-name">{{ loginStore.userData.nome }}</div>
                        <div class="establishment-name">{{ loginStore.userData.nmmunicipio }}</div>
                    </div>
                    <div class="token-info">{{ timeRemaining }}</div>
                </div>
            </header>
            <div class="main-content">
                <slot>
                    <div v-if="nmComponenteAtivo=='GabAgendaPrefeitoPage'"><GabAgendaPrefeitoPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='GabAgendaRecepcaoPage'"><GabAgendaRecepcaoPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='GabineteAgendaCalendarioPage'"><GabineteAgendaCalendarioPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='GabineteAgendaEditPage'"><GabineteAgendaEditPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='GabineteAgendaTabPage'"><GabineteAgendaTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='GabineteAtendimentoExpressoEditPage'"><GabineteAtendimentoExpressoEditPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='GabinetePessoasTabPage'"><GabinetePessoasTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='GabSolicitacaoIncluirPage'"><GabSolicitacaoIncluirPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='GabSolicitacoesTabPage'"><GabSolicitacoesTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='UsuarioViewPage'"><UsuarioViewPage :idView=loginStore.userData.idusuario @close="setComponenteAtivo(null, null)"/></div>
                    
                    <div v-else-if="nmComponenteAtivo=='GabineteDepartamentosTabPage'"><GabineteDepartamentosTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='GabineteTpPessoasTabPage'"><GabineteTpPessoasTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='UsuariosTabPage'"><UsuariosTabPage @close="setComponenteAtivo(null, null)"/></div>

                    <div v-else-if="nmComponenteAtivo=='GabAgendaReportPage'"><GabAgendaReportPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='GabineteAniversariantesReportPage'"><GabineteAniversariantesReportPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='GabineteRequisicoesReportPage'"><GabineteRequisicoesReportPage @close="setComponenteAtivo(null, null)"/></div>
                    <!-- <div v-else><IpOSAdminDash /></div> -->
                </slot>
            </div>
        </main>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { globalStore } from '@/globals';
import { jwtDecode } from 'jwt-decode';
import { useLoginStore } from '@/store/login';
import { useRouter } from 'vue-router';

import GabAgendaPrefeitoPage from '../gabinete/GabAgendaPrefeitoPage.vue';
import GabAgendaRecepcaoPage from '../gabinete/GabAgendaRecepcaoPage.vue';
import GabineteAgendaCalendarioPage from '../gabinete/GabineteAgendaCalendarioPage.vue';
import GabineteAgendaEditPage from '../gabinete/GabineteAgendaEditPage.vue';
import GabineteAgendaTabPage from '../gabinete/GabineteAgendaTabPage.vue';
import GabineteAtendimentoExpressoEditPage from '../gabinete/GabineteAtendimentoExpressoEditPage.vue';
import GabinetePessoasTabPage from '../cadastros/tabelas/GabinetePessoasTabPage.vue';
import GabSolicitacaoIncluirPage from '../gabinete/GabSolicitacaoIncluirPage.vue';
import GabSolicitacoesTabPage from '../gabinete/GabSolicitacoesTabPage.vue';
import UsuarioViewPage from '../cadastros/visualizacoes/UsuarioViewPage.vue';

// SUBMENU CONFIGURAÇÕES
import GabineteDepartamentosTabPage from '../cadastros/tabelas/GabineteDepartamentosTabPage.vue';
import GabineteTpPessoasTabPage from '../cadastros/tabelas/GabineteTpPessoasTabPage.vue';
import UsuariosTabPage from '../cadastros/tabelas/UsuariosTabPage.vue';

// SUBMENU RELATÓRIOS
import GabAgendaReportPage from '../reports/GabAgendaReportPage.vue';
import GabineteAniversariantesReportPage from '../reports/GabineteAniversariantesReportPage.vue';
import GabineteRequisicoesReportPage from '../reports/GabineteRequisicoesReportPage.vue';

const ckLoginAdmin= ref(false);
const ckGestor= ref(false);
const ckRecepcao= ref(false);
const ckSu= ref(false);
const isCollapsed = ref(true);
const nmComponenteAtivo = ref(null);
const nmTitulo = ref(null);
const router = useRouter();
const showRelatoriosMenu = ref(false);
const showSettingsMenu = ref(false);
const timeRemaining = ref(null);
const loginStore = useLoginStore();
let timer = null;

const menuIcon = computed(() => {
    return isCollapsed.value
        ? require('@/assets/icons/menuRight.svg')
        : require('@/assets/icons/menuLeft.svg');
});

const confirmLogout = () => {resetLogin();}

const resetLogin = () => {
    loginStore.clearLogin();
    router.push('/login');
}

const toggleMenu = () => { isCollapsed.value = !isCollapsed.value; }

const selectOption = (page, titulo) => {
    nmComponenteAtivo.value   = page;
    nmTitulo.value            = titulo;
    showRelatoriosMenu.value  = false;
    showSettingsMenu.value    = false;
}

const setComponenteAtivo = (nome, titulo) => {
    nmComponenteAtivo.value = nome;
    nmTitulo.value = titulo;
}

const updateTimeRemaining = () => {
    const token = localStorage.getItem('jwtToken');
    if (token){
        try{
            const decodedToken = jwtDecode(token);
            const expiration = decodedToken.exp * 1000;
            const now = Date.now();
            const difference = expiration - now;

            if (difference > 0){
                const hours         = Math.floor((difference / (1000 * 60 * 60)) % 24);
                const minutes       = Math.floor((difference / (1000 * 60)) % 60);
                const seconds       = Math.floor((difference / 1000) % 60);
                const formattedTime = [
                    hours.toString().padStart(2, '0'),
                    minutes.toString().padStart(2, '0'),
                    seconds.toString().padStart(2, '0')
                ].join(':');
                timeRemaining.value = formattedTime;
            }else{
                timeRemaining.value = "Token expirado";
                clearInterval(timer);
                // TODO: REDIRECIONAR PARA TELA DE LOGIN OU EMITIR ALERTA E REATIVAR A SESSÃO
            }
        }catch(error){
            console.error('Erro ao decodificar o token:', error);
            timeRemaining.value = "Erro ao verificar o token";
            clearInterval(timer);
        }
    } else {
        timeRemaining.value = "Token não encontrado";
        clearInterval(timer);
        // TODO: REDIRECIONAR PARA TELA DE LOGIN OU EMITIR ALERTA E REATIVAR A SESSÃO
    }
};

onMounted(() => {
    updateTimeRemaining();
    timer = setInterval(updateTimeRemaining, 1000);
    ckLoginAdmin.value = globalStore.ckadmin==='S';
    ckGestor.value = globalStore.perfil.gab_gestor;
    ckRecepcao.value = globalStore.perfil.gab_recepcao;
    ckSu.value = globalStore.perfil.gab_su;
});

onBeforeUnmount(() => {
    clearInterval(timer);
});
</script>

<style scoped src="@/assets/css/main.css"></style>
